export default "__VITE_ASSET__DWMmdsM6__"